import * as React from "react";
import PropTypes from 'prop-types';

export const PageTemplate = (props) => {
    let { objectName, pageTitle, children } = props;
    return <div className="container-fluid body-content hp">
        <div className="row">
            <div className="col-12 maxWidth-content">
                <div className="hp-title">
                    {pageTitle}
                </div>
            </div>
            <hr className="full-width" />
            <div className="col-12 maxWidth-content">
                <div className={objectName + "-wrapper"}>
                    <div className={objectName + "-container"}>
                        {children}
                    </div>
                </div>
            </div>
        </div>
    </div >;
}

PageTemplate.propTypes = {
    objectName: PropTypes.string, //used in classNames
    pageTitle: PropTypes.string, //displayed at top of page
    children: PropTypes.node
}